import { CALL_API } from '../middleware/api'
import moment from 'moment'
import { translations } from '../translations'
import { normalizeFormErrors } from '../normalizers/FormErrorsNormalizer'
import { normalizeErrors } from '../normalizers/ErrorsNormalizer'
import { setLanguage } from 'redux-i18n'

// API call
const simpleFetchCall = (endpoint, init, types, requestMeta, prefixURL) => ({
	[CALL_API]: { types, endpoint, init, requestMeta, prefixURL }
})
export const simpleFetch = (endpoint, init, type, requestMeta = {}, prefixURL = '/api/v1') => (dispatch, getState) => {
	let types = [type + '_REQUEST', type + '_SUCCESS', type + '_FAILURE']
	return dispatch(simpleFetchCall(endpoint, init, types, requestMeta, prefixURL))
}

export const LOGOUT = 'LOGOUT'
const logout = () => ({ type: LOGOUT })

export const processLogout = () => (dispatch, getState) => {
	localStorage.removeItem("pootsy-token")
	localStorage.removeItem("pootsy-token-expiration-date")
	dispatch(logout())
}

export const SHOW_SPINNER = 'SHOW_SPINNER'
export const HIDE_SPINNER = 'HIDE_SPINNER'
export const showSpinner = (mess, requestId) => ({ type: SHOW_SPINNER, mess, requestId })
export const hideSpinner = requestId => ({ type: HIDE_SPINNER, requestId })

export const BACKEND_ERROR = 'BACKEND_ERROR'
export const BACKEND_FORM_ERROR = 'BACKEND_FORM_ERROR'
export const backendError = (error, status) => {

	if (error !== undefined) {
		let errors = error.errors

		if (typeof errors === 'object') {
			let form_errors = normalizeFormErrors(errors)
			return { type: BACKEND_FORM_ERROR, form_errors, status }
		}
	}
	let message = normalizeErrors(error)
	return { type: BACKEND_ERROR, error: message, status }
}

export const LOCALISED_ERROR = 'LOCALISED_ERROR'
export const localisedError = error => ({ type: LOCALISED_ERROR, error })

export const CLOSE_ERRORMODAL = 'CLOSE_ERRORMODAL'
export const closeErrorModal = () => ({ type: CLOSE_ERRORMODAL })

export const ADD_BLOG_POSTS = 'ADD_BLOG_POSTS'
export const addBlogPosts = posts => ({ type: ADD_BLOG_POSTS, posts })

export const getBlogPosts = () => (dispatch, getState) => {
	let { i18nState: { lang } } = getState()
	let paramLang = "&lang=" + lang

	if (lang === 'fr') {
		paramLang = ""
	}

	let url = 'https://blog.pootsy.be/wp-json/wp/v2/posts?_embed'+paramLang

	fetch(url)
		.then(response => response.json())
		.then(json => {
			let posts = json.filter((e, i) => i < 3).map(post => {
				let parser = new DOMParser()
				let thumb = post._embedded["wp:featuredmedia"][0].media_details ? post._embedded["wp:featuredmedia"][0].media_details.sizes.medium.source_url : ""
				return {
					id: post.id, date: moment(post.date).format('DD/MM/YYYY'),
					title: parser.parseFromString(post.title.rendered, "text/html").body.textContent,
					url: post.link,
					thumb
				}
			})
			dispatch(addBlogPosts(posts))
		})
}

export const setLang = lang => (dispatch, getState) => {
	if(!Object.keys(translations).includes(lang)){
		moment.locale("en")
		dispatch(setLanguage("en"))
		return
	}
	moment.locale(lang)
	dispatch(setLanguage(lang))
}


// WEBPACK FOOTER //
// ./src/actions/acCommon.js